import { Component } from "react";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends Component {
  componentDidCatch(error, errorInfo) {
    // Send error to Sentry with specific tags and context
    Sentry.withScope((scope) => {
      // Add tags for easier filtering
      scope.setTag("error_type", "react_error_boundary");
      scope.setTag("error_location", "component_error");

      // Add custom context/metadata
      scope.setContext("component_info", {
        componentStack: errorInfo.componentStack,
        errorBoundary: true,
        timestamp: new Date().toISOString(),
      });

      // Add backend error context if available
      if (error.response?.data) {
        scope.setContext("backend_error_details", {
          status: error.response.status,
          data: error.response.data,
          url: error.response.config?.url,
        });
      }

      // You can also set a specific error level
      scope.setLevel("error");

      // Capture the exception with all the added context
      Sentry.captureException(error);
    });

    // Keep the console logs for local debugging
    console.log("error", error);
    console.log("errorInfo", errorInfo);

    // Enhanced error message handling
    const backendMessage = error.response?.data?.message || 
      error.response?.data?.detail ||
      (error.response?.data?.non_field_errors && error.response.data.non_field_errors.join(', '));
    
    const displayMessage = backendMessage ||
      JSON.stringify(error.response?.data)?.slice(0, 200) ||
      error.message ||
      "😥 An error has occurred. We sent the logs for study and reloaded the page.";

    toast(displayMessage);
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;